import { render, staticRenderFns } from "./ImgCaptcha.vue?vue&type=template&id=0db86d4a&scoped=true&"
import script from "./ImgCaptcha.vue?vue&type=script&lang=js&"
export * from "./ImgCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./ImgCaptcha.vue?vue&type=style&index=0&id=0db86d4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db86d4a",
  null
  
)

export default component.exports